import { TimeHelper } from '@/helpers/TimeHelper';
import { daysOfWeek } from '@/config/Time';

class ReportModel {
  id;
  author;
  createdOn;
  name;
  status;
  schedule;
  type;
  groups;
  recipients;
  logs;
  dayOfWeek;
  timeOfDay;
  possibleHours;
  possibleDays;
  possibleNotificationTypes;
  notificationType;

  constructor(data) {
    this.populate(data || {});
  }

  get dateCreated() {
    return TimeHelper.formatDate(this.createdOn);
  }

  doesValidate() {
    return this.name != '' && this.name.length >= 5
  }

  populate(data) {
    this.id = data.id || null;
    this.createdOn = data.createdOn || null;
    this.name = data.name || '';
    this.status = data.status || 'active';
    this.schedule = data.schedule || 'weekly';
    this.type = data.type || 'detections';
    this.author = data.author || {};
    this.dayOfWeek = data.dayOfWeek || null
    this.timeOfDay = data.timeOfDay
    this.groups = [];
    this.recipients = []
    this.logs = []
    this.possibleDays = daysOfWeek
    this.deliveryType = data.deliveryType || 1
    this.possibleHours = {
      6: '6AM',
      7: '7AM',
      8: '8AM',
      9: '9AM',
      10: '10AM',
      11: '11AM',
      12: '12PM',
      13: '1PM',
      14: '2PM',
      15: '3PM',
      16: '4PM',
      17: '5PM',
      18: '6PM',
      19: '7PM',
      20: '8PM'
    },
    this.possibleDeliveryTypes = {
      1: "Email",
      2: "PN",
      3: "SMS",
      4: "Email + PN",
      5: "Email + SMS",
      6: "PN + SMS",
      7: "Email + PN + SMS"
    }
  }

  get isWeekly() {
    return this.schedule === 'weekly'
  }

  get isMonthly() {
    return this.schedule === 'monthly'
  }

  toDetailsUpdateJson(originalData) {
    let output = {};
    if (this.name !== originalData.name) output.name = this.name;
    if (this.schedule !== originalData.schedule) output.schedule = this.schedule;
    if (this.status !== originalData.status) output.status = this.status;
    if (this.type !== originalData.type) output.type = this.type;
    if (this.dayOfWeek !== originalData.dayOfWeek) output.dayOfWeek = this.dayOfWeek;
    if (this.timeOfDay !== originalData.timeOfDay) output.timeOfDay = this.timeOfDay;
    if (this.deliveryType !== originalData.deliveryType) output.deliveryType = this.deliveryType;
    return output; // TODO first check if object is empty
  }

  exportToCreate() {
    return {
      name: this.name,
      type: this.type,
      schedule: this.schedule,
      status: this.status,
      dayOfWeek: this.dayOfWeek,
      timeOfDay: this.timeOfDay,
      deliveryType: this.deliveryType
    }
  }
}

export { ReportModel };
